import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FilterSelect from '../components/common/FilterSelect';

import ElectedCard from '../components/common/ElectedCard';

const elected = [
  { name: 'Chiara Mancini', role: 'Consigliera Regionale', territory: 'Regione Lazio', avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop' },
  { name: 'Luca Moretti', role: 'Consigliere Comunale', territory: 'Comune di Firenze', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop' },
  { name: 'Valentina Costa', role: 'Consigliera Municipale', territory: 'Municipio III, Roma', avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop' },
  { name: 'Marco Viesti', role: 'Consigliere Comunale', territory: 'Comune di Milano', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&auto=format&fit=crop' },
  { name: 'Giulia Ferri', role: 'Consigliera Regionale', territory: 'Regione Toscana', avatar: 'https://images.unsplash.com/photo-1567532939604-b6c5b0ad2e01?q=80&w=200&auto=format&fit=crop' },
  { name: 'Andrea Ferrarin', role: 'Consigliere Comunale', territory: 'Comune di Bologna', avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=200&auto=format&fit=crop' },
];

const ElettiPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Eletti' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Istituzioni" title="I nostri Eletti" subtitle="Oltre 200 giovani democratici rappresentano la nostra comunità nelle istituzioni." />
      <section className="section section--sm"><div className="container">
        <Toolbar className="mb-6"
          left={<SearchBar placeholder="Cerca eletto..." ariaLabel="Cerca" />}
          right={
            <>
              <FilterSelect label="Livello" options={['Tutti', 'Regionale', 'Provinciale', 'Comunale', 'Municipale']} />
              <FilterSelect label="Ruolo" options={['Tutti', 'Sindaco', 'Assessore', 'Consigliere', 'Presidente']} />
              <FilterSelect label="Regione" options={['Tutte', 'Lazio', 'Toscana', 'Lombardia']} />
              <FilterSelect label="Provincia" options={['Tutte', 'Roma', 'Firenze', 'Milano', 'Bologna']} />
              <FilterSelect label="Comune" options={['Tutti', 'Roma', 'Firenze', 'Milano', 'Bologna']} />
            </>
          }
        />
        <div className="grid grid-3">{elected.map((e) => <ElectedCard key={e.name} {...e} />)}</div>
      </div></section>
    </Layout>
  );
};

export default ElettiPage;
